import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RedeemActions, burnFormValuesSelector } from 'features'
import { rewardPublicSelector, useModal } from 'primsell-shared-layer/features'

import { ModalVariantE } from 'types'
import { BurnNftModal } from 'components'

const BurnRewardNftModal = () => {
  const { openModal } = useModal()
  const dispatch = useDispatch()

  const rewardPublicDetails = useSelector(rewardPublicSelector)
  const formValues = useSelector(burnFormValuesSelector)

  const handleBurn = useCallback(() => {
    dispatch(
      RedeemActions.redeemRewardRequest({
        code: rewardPublicDetails?.tokenId as string,
        email: formValues?.email as string,
        firstName: formValues?.firstName as string,
        lastName: formValues?.lastName as string,
      })
    )
    openModal({ variant: ModalVariantE.REDEEM_PROGRESS_MODAL })
  }, [
    dispatch,
    rewardPublicDetails?.tokenId,
    formValues?.email,
    formValues?.firstName,
    formValues?.lastName,
    openModal,
  ])

  return <BurnNftModal handleBurn={handleBurn} />
}

export { BurnRewardNftModal }
